/**
 * 删除当前页记录后修正页码。
 * 当当前页最后一条数据被删除时回退一页，避免停留在空白页。
 */
export function retreatPageAfterDelete(pagination, currentPageRowCount, deletedCount = 1) {
  if (!pagination || Number(pagination.current) <= 1) return
  if (Number(currentPageRowCount) <= Number(deletedCount)) {
    pagination.current = Number(pagination.current) - 1
  }
}
